/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Factor } from './Factor';
import {
    FactorFromJSON,
    FactorFromJSONTyped,
    FactorToJSON,
} from './Factor';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
} from './PersonHandle';

/**
 * 
 * @export
 * @interface IDRequest
 */
export interface IDRequest {
    /**
     * 
     * @type {PersonHandle}
     * @memberof IDRequest
     */
    handle?: PersonHandle;
    /**
     * 
     * @type {Factor}
     * @memberof IDRequest
     */
    factor?: Factor;
}

/**
 * Check if a given object implements the IDRequest interface.
 */
export function instanceOfIDRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IDRequestFromJSON(json: any): IDRequest {
    return IDRequestFromJSONTyped(json, false);
}

export function IDRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'handle': !exists(json, 'handle') ? undefined : PersonHandleFromJSON(json['handle']),
        'factor': !exists(json, 'factor') ? undefined : FactorFromJSON(json['factor']),
    };
}

export function IDRequestToJSON(value?: IDRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'handle': PersonHandleToJSON(value.handle),
        'factor': FactorToJSON(value.factor),
    };
}

